<template>
    <ESelect
        v-model="choiceEle"
        :multiple="multiple"
        collapse-tags
        filterable
        :filter-method="SearchFilter"
        :placeholder="placeholder"
        :style="{width: width + 'px'}"
        class="de-tags-select-mul"
        ref="allSelect"
        :clearable="clearable"
        reserve-keyword
        :remote="remote"
        :remote-method="remoteMethod"
        :loading="loading"
        :disabled="disabled"
        :no-data-text="noDataText"
        @visible-change="handleVisible"
        @change="handleChange"
    >
        <div :style="{cursor: 'pointer', paddingLeft: '20px', marginBottom: '6px', color: '#409EFF'}" v-if="multiple">
            <span :style="{display: 'inline-block'}"  @click="handleAllSelect('all')">全选</span>
            <span :style="{display: 'inline-block', marginLeft: '10px'}" @click="handleAllSelect('cancel')">取消全选</span>
        </div>
        <template v-if="virtual">
            <VirtualList
                ref="virtualList"
                data-key="uid"
                style="max-height: 245px; overflow-y: auto;"
                :data-sources="optionList"
                :data-component="itemComponent"
                :keeps="20"
                :estimate-size="50"
                class="detagWidth"
            />
        </template>
        <template v-else-if="group">
            <el-option-group
            v-for="group in optionList"
            :key="group.label"
            :label="group.label">
            <el-option :label="option.name || option.label" :value="option.id || option.value"
            v-for="option in group.children" :key="option.id"></el-option>
            </el-option-group>
        </template>
        <template v-else>
            <el-option :label="option.name || option.label" :value="option.id || option.value"
                       v-for="option in optionList" :key="option.id"></el-option>
        </template>
    </ESelect>
</template>

<script>
/**
 *
 */
import VirtualList from 'vue-virtual-scroll-list';
import OptionsItem from './virtualListItem';
import {uniq, uniqBy} from 'lodash'
import  { Select }  from '@/views/mixins/ele'
import { ESelect } from '@/components/Ele/eSelect';
export default {
    name: 'SelectAll',
    mixins:  [ Select({ ref:'allSelect', list: 'optionList' }) ],
    components: {
        VirtualList,
        ESelect,
    },
    props: {
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        multiple: {
            type: Boolean,
            default: true
        },
        remote: {
            type: Boolean,
            default: false
        },
        remoteQuery: {
            type: Function,
            default: (query) => {}
        },
        clearable: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: "请选择"
        },
        width: {
            type: Number,
            default: 180

        },
        lineHeight: {
            type: Number,
            default: 28
        },
        checkStrictly: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: "mini"
        },
        value: {
            type: [Array, String, Number],
            default: () => {
                return this?.multiple ? [] : '';
            }
        },
        virtual: {
            type: Boolean,
            default: false
        },
        group: {
            type: Boolean,
            default: false
        },
        disabled:{
            type: Boolean,
            default: false
        },
        noDataText: {
            type: String,
            default: "无数据"
        }
    },
    data() {
        return {
            optionList: [],
            lastSelectedList: [],
            choiceEle: [],
            itemComponent: OptionsItem,
            loading:false,
            remoteOptions:[]

        }
    },
    watch: {
        'options': {
            handler(n, o){
                this.optionList = n
            },
            deep:true,
            immediate: true
        },
        'value': {
            handler(n, o){
                this.choiceEle = n ? n : this.multiple ? [] : ''
            },
            immediate: true
        },
    },
    mounted() {

    },
    methods: {
        handleVisible(value) {
            if(!value) {
                this.optionList = []
                if(this.remote) {
                    this.optionList = this.remoteOptions
                }else{
                this.optionList = this.options
                }
                if(this.virtual) {
                    this.$refs.virtualList.reset()
                }
            }
        },
        SearchFilter(val) {
            if(this.group) {
                this.optionList = this.options.map(ele => {
                    return {
                        label: ele.label,
                        children: ele.children.filter(item => (item.name || item.label).toLowerCase().indexOf(val.toLowerCase()) > -1)
                    };
                }).filter(ele => ele.children.length > 0);
            }else{
            this.optionList = this.options.filter(item=> {
                    return (item.name || item.label).toLowerCase().indexOf(val.toLowerCase()) > -1
                })
            }

        },
        remoteMethod(query) {
            if(!query) return
            this.loading = true
            this.remoteQuery(query).then(res=>{
                this.optionList = res.data
            }, err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.loading = false
            })
        },


        handleAllSelect(type) {
            console.log(type,'this.optionList',this.optionList);
            
            if(!this.multiple) return
            if(type == 'all') {
                let append = []
                if(this.group) {
                    this.optionList.forEach(element => {
                        element.children.forEach(item=>{
                            append.push(item.id || item.value)
                        })
                    });
                }else{
                    append = this.optionList.map(item=>item.id)

                }
                this.choiceEle = uniq([...this.choiceEle, ...append])
            }else{
                let optionList_ids = []
                if(this.group) {
                    this.optionList.forEach(element => {
                        element.children.forEach(item=>{
                            optionList_ids.push(item.id || item.value)
                        })
                    });
                }else{
                    optionList_ids = this.optionList.map(item=>item.id)
                }
                let channel_ids = this.choiceEle.filter(item=> !optionList_ids.includes(item))
                this.choiceEle = uniq([...channel_ids])
            }
            this.$refs['allSelect'].blur()
            this.$emit('input', this.choiceEle)
        },
        handleChange(value) {
            this.choiceEle = value
            this.$emit('input', value)
        }
    }

};
</script>

<style lang="scss">
.de-tags-select-mul {
    .el-select__tags{
        height: 22px;
        white-space: nowrap;
        overflow:hidden;
        flex-wrap: nowrap;
    }
    .el-select__tags-text{
        display: inline-block;
        max-width: 85px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>

